import { IArticleTransformed } from '../features/article/types/IArticleTransformed'
import MpTrackingButtons from './types/mpTrackingButtons'
import mixpanel from 'mixpanel-browser'
import { IPages } from '../shared/types/IPages'
import { isArticleWidget } from '../shared/utils/url'

export const mpInit = () => {
    const token =
        process.env.REACT_APP_NODE_ENV === 'production' || process.env.REACT_APP_NODE_ENV === 'staging'
            ? '59d23f328104fb6705ddf30c3be242e7'
            : 'cae6f505b6edd1f160105f161721e537'

    mixpanel.init(token, { api_host: 'https://api-eu.mixpanel.com' })

    console.log('MP - Init - Success')
}

export const mpSetUserProperties = () => {
    const trackingPoperties = {
        UserPlatform: 'EMBED_PLAYER',
        UserSubPlatform: isArticleWidget() ? 'ARTICLE_WIDGET' : 'PLAYLIST_WIDGET',
    }

    // Send all events to embed tracking user
    mixpanel.identify('47347')

    mixpanel.people.set(trackingPoperties)

    mixpanel.register(trackingPoperties)
}

// EVENTS

export const mpTrackIntervalListen = (currentProgress: number, article?: IArticleTransformed) => {
    if (!article) {
        return
    }

    const trackingPoperties = {
        ArticleName: article.name,
        ArticleId: article.id,
        PublisherName: article.publisher.name,
        AudioLengthSecs: Math.round(article.audioLength.seconds),
        ListenProgressSecs: Math.round(currentProgress),
        ListenProgressPercent: +((Math.round(currentProgress) / Math.round(article.audioLength.seconds)) * 100).toFixed(
            2
        ),
    }

    trackEvent('ArticleListenInterval', trackingPoperties)
}

export const mpTrackArticleEnd = (currentProgress: number, article?: IArticleTransformed) => {
    if (!article || currentProgress <= 1) {
        return
    }

    const trackingPoperties = {
        ArticleName: article.name,
        ArticleId: article.id,
        PublisherName: article.publisher.name,
        AudioLengthSecs: Math.round(article.audioLength.seconds),
        ListenProgressSecs: Math.round(currentProgress),
        ListenProgressPercent: +((Math.round(currentProgress) / Math.round(article.audioLength.seconds)) * 100).toFixed(
            2
        ),
    }

    trackEvent('ArticleEnd', trackingPoperties)
}

export const mpTrackButtonClick = (button: MpTrackingButtons, article?: IArticleTransformed) => {
    const trackingPoperties = {
        ArticleName: article?.name,
        ArticleId: article?.id,
        PublisherName: article?.publisher.name,
        ButtonName: button.toString(),
    }

    trackEvent('ButtonClick', trackingPoperties)
}

export const mpTrackPageChange = (page: IPages, article?: IArticleTransformed) => {
    const trackingPoperties = {
        PublisherName: article?.publisher.name,
        pageName: page,
    }

    trackEvent('PageClick', trackingPoperties)
}

export const mpTrackClickHereCta = (article?: IArticleTransformed) => {
    const trackingPoperties = {
        PublisherName: article?.publisher.name,
    }

    trackEvent('ClickHereCta', trackingPoperties)
}

export const mpTrackArticleTextButton = (article?: IArticleTransformed) => {
    const trackingPoperties = {
        PublisherName: article?.publisher.name,
        ArticleName: article?.name,
        ArticleId: article?.id,
    }

    trackEvent('ArticleTextButton', trackingPoperties)
}

export const mpTrackPlaybackSpeedChange = (speedLevel: number, article?: IArticleTransformed) => {
    const trackingPoperties = {
        PublisherName: article?.publisher.name,
        ArticleName: article?.name,
        ArticleId: article?.id,
        speedLevel,
    }

    trackEvent('PlaybackSpeedChange', trackingPoperties)
}

export const mpTrackVolumeChange = (volumeLevel: number, article?: IArticleTransformed) => {
    const trackingPoperties = {
        PublisherName: article?.publisher.name,
        ArticleName: article?.name,
        ArticleId: article?.id,
        volumeLevel,
    }

    trackEvent('VolumeChange', trackingPoperties)
}

export const mpTrackSearchText = (text: string, article?: IArticleTransformed) => {
    const trackingPoperties = {
        PublisherName: article?.publisher.name,
        searchText: text,
    }

    trackEvent('SearchText', trackingPoperties)
}

export const mpTrackAddQueue = (article?: IArticleTransformed) => {
    const trackingPoperties = {
        PublisherName: article?.publisher.name,
        ArticleName: article?.name,
        ArticleId: article?.id,
    }

    trackEvent('AddQueue', trackingPoperties)
}

export const mpTrackRemoveQueue = (article?: IArticleTransformed) => {
    const trackingPoperties = {
        PublisherName: article?.publisher.name,
        ArticleName: article?.name,
        ArticleId: article?.id,
    }

    trackEvent('RemoveQueue', trackingPoperties)
}

const trackEvent = async (eventName: string, props: any) => {
    mpSetUserProperties()

    const parentUrl = document.referrer ? document.referrer.split('?')[0] : undefined

    const eventProps = { ...props, parentUrl: parentUrl }

    mixpanel.track(eventName, eventProps)

    // @ts-ignore
    if (window.fbq) {
        // @ts-ignore
        window.fbq('track', eventName, eventProps)
    }

    console.log(`Noa - MP - FB - ${eventName}:\n${JSON.stringify(eventProps)}\n`)
}
